export const getGoogleMapsUrl = (input) => {
    if (!input) return "https://maps.google.com"; // Default URL
  
    // Check if input is latitude & longitude (comma-separated numbers)
    const latLongPattern = /^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/;
    if (latLongPattern.test(input)) {
      return `https://www.google.com/maps?q=${input}`;
    }
  
    // Check if input is an IP address (Basic handling, IPs don’t work directly on Maps)
    const ipPattern = /^(?:\d{1,3}\.){3}\d{1,3}$/;
    if (ipPattern.test(input)) {
      return "https://www.google.com/maps"; // Redirects to Google Maps home
    }
  
    // Assume input is an address, encode it for URL
    return `https://www.google.com/maps?q=${encodeURIComponent(input)}`;
  };
  